export default () => {
  const errorList = document.getElementsByClassName('ssc-form-item-error');
  errorList.length > 0 &&
    errorList[0].scrollIntoView({
      block: 'nearest',
      behavior: 'smooth',
    });
};
